import "./LoginRegister.scss";
import SiemensLogo from "../../assets/images/siemens-logo-petrol.svg";
import IntraLogo from "../../assets/images/sie-intranet-black-rgb.svg";
import { Container, Grid2, styled } from "@mui/material";
import LoginRegisterTabs from "./LoginRegisterTabs";
import { Height } from "@mui/icons-material";



styled(Container)((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "rgba(0, 204, 204, .05)",
    backdropFilter: "blur(1px)",
    height:"100vh",
    width:"100%",
    overflow:"hidden"
  },

}));


const useStyles = styled(Container)((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "rgba(0, 204, 204, .05)",
    backdropFilter: "blur(1px)",
    minHeight: "100vh",
    overflow: "hidden",
  },
  paper: {
    padding: theme.spacing(2),
  },
  errorMessage: {
    color: "var(--red)",
    fontSize: "16px",
  },
  timerDetails: {
    backgroundColor: "var(--bg-green-2)",
  },
  forgotPwd: {
    textAlign: "center",
    textDecoration: "underline",
  },
  loginTabs: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "15px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: "0px",
  },
}));

export default function LoginRoot() {
  return (
    <div className="bg-login-register no-scrollbar">
      <Container
        maxWidth={false}
        sx={{
          flexGrow: 3,
          backgroundColor: "rgba(0, 204, 204, .05)",
          backdropFilter: "blur(1px)",
          minHeight: "110vh",
          backgroundPosition:'inherit',
          //position:'absolute'
          // overflow: "hidden",
          // width: "100%",
          
        }}
      >
        <Grid2 item="true" xs={12}>
          <div className="ssiat-login-logo-block">
            <img src={SiemensLogo} className="official-logo" alt="Siemens" />
          </div>
        </Grid2>
        <Grid2 container className="ssiat-lr-mobileContainer">
          <Grid2
            item="true"
            xs={12}
            sm={12}
            md={6}
            className="ssiat-lr--project-block"
          >
            <div className="ssiat-lr--project">
              <p className="ssiat-lr-project-name">
                DB Configuration Tool
                <sup>
                  <img
                    src={IntraLogo}
                    alt="Intra Logo"
                    className="ssiat-intra-logo"
                  />
                </sup>
              </p>
            </div>
          </Grid2>
          <Grid2
            item="true"
            xs={12}
            sm={12}
            md={6}
            className="ssiat-lr--master-block"
          >
            {<LoginRegisterTabs />}
          </Grid2>
        </Grid2>
      </Container>
    </div>
  );
}
